import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "@/lib/admin-api";
import type { ProductSource } from "@/types";

/**
 * Fetch the networks (product sources) once on mount for filter/form selects. Mirrors
 * passport-admin's use-products hook: cancelled guard, graceful degradation (empty list + one
 * toast on error). pageSize 200 is a documented v1 cap — dev fixtures ship 4 networks.
 */
export function useNetworkOptions(): { networks: ProductSource[]; isLoading: boolean } {
  const [networks, setNetworks] = useState<ProductSource[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    adminApi.sources
      .list({ pageSize: 200, sortBy: "name" })
      .then((res) => {
        if (!cancelled) setNetworks(res.items);
      })
      .catch((err) => {
        if (!cancelled)
          toast.error(err instanceof Error ? err.message : "Failed to load networks.");
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { networks, isLoading };
}
